import { Delete, Edit } from "@material-ui/icons";
import { DataGrid } from "@mui/x-data-grid";
import { useState } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import Dialog from "../../designSystem/Dialog";
import { defaultNestedValues } from "./companyProfileDtos";
import { useDeleteCompanyDockMutation } from "../../../features/admin/companyProfile/companyProfileSlice";
import errorHandler from "../../hooks/ErrorHanlder";
import { toast } from "react-toastify";
import useCustomer from "../../../context/CustomerContext";

const DockList = ({ shouldCallBackend, editCompanyDock }) => {
    const [deleteCompanyDock] = useDeleteCompanyDockMutation();
    const { getValues, setValue, control } = useFormContext();
    const docks = useWatch({ name: "docks", control });
    const [rowToDelete, setRowToDelete] = useState(null);
    const { companyProfile } = useCustomer();

    const deleteHandler = async () => {
        if (rowToDelete == null) return;

        if (shouldCallBackend) {
            try {
                await deleteCompanyDock({
                    CompanyProfileID: companyProfile.companyProfileID,
                    DockId: rowToDelete
                }).unwrap();
                toast.success("Dock deleted successfully", { position: "top-center" });
            } catch (err) {
                errorHandler(err);
            }

        } else {
            const updated = docks.filter(d => d.dockID !== rowToDelete);
            setValue("docks", updated, { shouldValidate: true });
            if (getValues("dockForm.dockID") === rowToDelete) {
                setValue("dockForm", {
                    ...defaultNestedValues,
                    dockName: "",
                    isPrimary: false,
                });
            }
        }

        setRowToDelete(null);
    };

    return (
        <div style={{ height: "400px", background: "white", marginTop: "20px", padding: "0px !important" }}>
            <Dialog title={"Delete Dock"} show={!!rowToDelete} onClose={() => setRowToDelete(null)} description={"Are you sure you want to Delete Dock"} onSubmit={deleteHandler} />

            <DataGrid
                sx={{ p: "0px" }}
                rows={docks || []}
                getRowId={(row) => row.dockID}
                columns={[
                    {
                        field: "actions",
                        headerName: "Actions",
                        sortable: false,
                        width: 200,
                        disableClickEventBubbling: true,
                        renderCell: (data) => {
                            const onEditClick = async (e) => {
                                e.stopPropagation();
                                const dock = data.row;
                                Object.entries(dock).forEach(([key, val]) =>
                                    setValue(`dockForm.${key}`, val)
                                );
                            };
                            const onDeleteClick = (e) => {
                                e.stopPropagation();
                                setRowToDelete(data.row.dockID);
                            };

                            return (
                                <div className="action_btn">
                                    <span className="edit_btn" onClick={onEditClick}><Edit /></span>
                                    <span className="del_btn" onClick={onDeleteClick}><Delete /></span>
                                </div>
                            )
                        },
                    },
                    { field: "dockName", headerName: "Dock Name", width: 180 },
                    { field: "streetNo", headerName: "Street No", width: 130 },
                    { field: "streetName", headerName: "Street Name", width: 180 },
                    {
                        field: "city", headerName: "City", width: 130, valueGetter: (params) => {
                            return Array.isArray(params.row.city) && params.row.city.length > 0
                                ? params.row.city[0].name
                                : ""
                        }
                    },
                    {
                        field: "province", headerName: "Province", width: 130, valueGetter: (params) => {
                            return Array.isArray(params.row.provinceList?.data?.data) && params.row.provinceList?.data?.data.length > 0
                                ? params.row.provinceList?.data?.data?.find((p) => p.provineStateID === Number(params.row.province))?.provineSateName
                                : ""
                        }
                    },
                    {
                        field: "country", headerName: "Country", width: 130, valueGetter: (params) => {
                            return Array.isArray(params.row.countryList?.data?.data) && params.row.countryList?.data?.data.length > 0
                                ? params.row.countryList?.data?.data[0].countryname
                                : ""
                        }
                    },
                    { field: "postalCode", headerName: "Postal Code", width: 130 },
                    {
                        field: "isPrimary",
                        headerName: "Primary?",
                        width: 100,
                        renderCell: (params) => (
                            <input
                                type="radio"
                                checked={params.row.isPrimary}
                                value={params.row.id}
                                name="primaryDockRadioGroup"
                                aria-label={`select row ${params.row.id}`}
                                onChange={async () => {
                                    const updated = docks.map(d => ({
                                        ...d,
                                        isPrimary: d.dockID === params.row.dockID
                                    }));

                                    if (shouldCallBackend && companyProfile?.companyProfileID) {
                                        try {
                                            const updatedDock = {
                                                dockID: params.row.dockID,
                                                dockName: params.row.dockName,
                                                dockCode: params.row.dockCode ?? 0,
                                                dockStreetNo: params.row.streetNo,
                                                dockStreetName: params.row.streetName,
                                                dockCity: params.row.city[0]?.name,
                                                dockProvince: params.row.provinceList?.data?.data[0]?.provineSateName,
                                                dockCountry: params.row.country === 2 ? "USA" : "CAN",
                                                dockPostalCode: params.row.postalCode,
                                                isPrimary: true
                                            };
                                            await editCompanyDock({
                                                CompanyProfileID: companyProfile.companyProfileID,
                                                ...updatedDock
                                            }).unwrap();

                                            toast.success("Primary dock updated", { position: "top-center" });
                                        } catch (err) {
                                            errorHandler(err);
                                        }
                                    } else {
                                        setValue("docks", updated, { shouldValidate: true });
                                    }
                                }}
                            />
                        )
                    }
                ]}
            />
        </div>
    )
}

export default DockList